import { render, staticRenderFns } from "./NotificationsCenterHeader.vue?vue&type=template&id=381b65bc&scoped=true&"
import script from "./NotificationsCenterHeader.vue?vue&type=script&lang=ts&"
export * from "./NotificationsCenterHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsCenterHeader.vue?vue&type=style&index=0&id=381b65bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b65bc",
  null
  
)

export default component.exports